import { Autocomplete, Box, Button, CircularProgress, IconButton, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, tableCellClasses } from "@mui/material";
import { useAuthContext } from "../../../hooks/useAuthContext";
import styled from "@emotion/styled";
import { transactions_method_en, transactions_method_fr } from "../../../components/data/withdrawColumns";
import { useEffect, useState } from "react";
import Api from "../../../api/Api";
import { Urls } from "../../../api/Urls";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import ContentBox from "../../../components/ui/ContentBox";
import ButtonSquare from "../../../components/ui/ButtonSquare";
import StatusComponent from "../../../components/ui/StatusComponent";
import moment from "moment";
import TableShowUser from "../../../components/ui/TableShowUser";
import { modalStyle, modalStyleOverflow } from "../../../theme/ModalStyle";
import FormikErrorText from "../../../components/ui/FormikErrorText";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useParams } from "react-router-dom";
const WithdrawRequests = () => {
  const { id } = useParams();
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "white",
      paddingTop: "8px",
      paddingBottom: "8px",
      letterSpacing: "1px",
      color: `rgba(75,70,92,0.8)`,
      fontSize: 15,
      fontWeight: 500,
    },
    [`&.${tableCellClasses.body}`]: {
      background: "white",
      fontSize: 15,
      color: `rgba(75,70,92,0.8)`,
      fontWeight: "500",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
    ":hover": {
      filter: "brightness(0.95)",
    },
    cursor: "pointer",
  }));

  const StyledTable = styled(Table)({
    borderRadius: "6px",
  });
  const { user } = useAuthContext();
  const access_token = user?.access_token;
  const lang = localStorage.getItem("i18nextLng");
  const [data, setData] = useState({});
  const [page, setPage] = useState(1);
  const [openRefuse, setOpenRefuse] = useState({ id: null, state: null });
  const [openAccept, setOpenAccept] = useState({ id: null, state: null });

  const [openDetails, setOpenDetails] = useState({ open: false, data: null });
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState(lang === "fr" ? transactions_method_fr : transactions_method_en);
  const [transactions, setTransactions] = useState([]);
  const { t } = useTranslation();
  const pageSize = 30;
  const [change, setChange] = useState(false);
  //get transactions
  const [pagesList, setPagesList] = useState([]);
  //handleClose accept
  const handleCloseAccept = () => {
    setOpenAccept({ id: null, state: null });
  };
  //handleClose refuse
  const handleCloseRefuse = () => {
    setOpenRefuse({ id: null, state: null });
  };
  useEffect(() => {
    Api.get(Urls.GetWithdrawRequestsByID(id), {
      headers: { "accept-language": localStorage.getItem("i18nextLng"), "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
      params: {
        page: page,
        perPage: pageSize,
        pageSize: pageSize,
      },
    })
      .then((res) => {
        setTransactions(res?.data?.data);
        setData(res?.data);
        if (pagesList?.length === 0) {
          let result = res?.data?.pagination?.total / pageSize;
          let array = [];
          if (result <= 1) {
            setPagesList([1]);
          } else {
            if (Number?.isInteger(result)) {
              for (let index = 1; index <= result; index++) {
                array.push(index);
              }
            } else {
              for (let index = 0; index <= result; index++) {
                array.push(index + 1);
              }
            }
            setPagesList(array);
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response.data?.message);
        setLoading(false);
      });
  }, [page, change]);

  //handle refuse kyc
  const handleRefuse = () => {
    Api.patch(
      Urls?.AcceptOrRefuseWithdrawRequest(openRefuse?.id, "reject"),
      {},
      {
        headers: { "accept-language": localStorage.getItem("i18nextLng"), "Content-type": "application/json", authorization: `Bearer ${access_token}` },
      }
    )
      .then((res) => {
        toast.success(res?.data?.message);
        setChange(!change);
        handleCloseRefuse();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  //handle accept kyc
  const handleAccept = () => {
    Api.patch(
      Urls?.AcceptOrRefuseWithdrawRequest(openAccept?.id, "approve"),
      {},
      {
        headers: { "accept-language": localStorage.getItem("i18nextLng"), "Content-type": "application/json", authorization: `Bearer ${access_token}` },
      }
    )
      .then((res) => {
        toast.success(res?.data?.message);
        setChange(!change);
        handleCloseAccept();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  return (
    <Box>
      <ToastContainer />
      <Box sx={{ maxWidth: "100%" }} display="flex" flexDirection="column" gap="24px">
        <Box>
          <Typography variant="text_md" color="rgba(0,0,0,0.5)">
            {t("sharedLayout.navigations.withdraw_requests")}
          </Typography>
        </Box>
        <Box>
          <ContentBox>
            <Box display="flex" flexDirection="column" gap="16px">
              <Box>
                <Typography variant="text_18" color="rgba(75, 70, 92 , 0.9)">
                  {t("pages.titles.withdraw_requests")}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" justifyContent="flex-end" flexWrap="wrap" gap="16px"></Box>
              {loading && (
                <Box display="flex" justifyContent="center">
                  <CircularProgress />
                </Box>
              )}
              {!loading && (
                <Box sx={{ overflow: "hidden", maxWidth: "100%" }}>
                  <TableContainer sx={{ borderRadius: "6px", border: `1px solid #DBDADE` }}>
                    <StyledTable aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          {columns.map((col, index) => (
                            <StyledTableCell key={index} width={col.width} align={col.align}>
                              {col.name}
                            </StyledTableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {transactions?.map((doc) => (
                          <StyledTableRow>
                            <StyledTableCell align="left">
                              <Typography fontWeight="400" color="#3890E2" fontSize="15px">
                                #{doc?.id}
                              </Typography>
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <TableShowUser full_name={doc?.user?.first_name + " " + doc?.user?.last_name} url_photo={doc?.user?.file_url} />
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <Box sx={{ display: "flex", flexDirection: "column" }}>
                                {!doc?.withdraw_method && <Typography>-</Typography>}
                                <Typography>{doc?.withdraw_method?.data?.holder_name}</Typography>
                                <Typography>{doc?.withdraw_method?.currency?.code}</Typography>
                                {doc?.withdraw_method?.data?.rib && <Typography>RIB : {doc?.withdraw_method?.data?.rib}</Typography>}
                                {doc?.withdraw_method?.data?.bic && <Typography>Bic : {doc?.withdraw_method?.data?.bic}</Typography>}
                              </Box>
                            </StyledTableCell>

                            <StyledTableCell align="left">{doc?.withdraw_method?.type}</StyledTableCell>
                            <StyledTableCell align="left">
                              {doc?.amount} {doc?.withdraw_method?.currency?.code}
                            </StyledTableCell>

                            <StyledTableCell align="center">
                              <StatusComponent text={doc?.status_display} name={doc?.status} />
                            </StyledTableCell>
                            <StyledTableCell align="center">{moment(doc?.created_at).format("DD MMMM yyyy HH:mm")}</StyledTableCell>
                            <StyledTableCell align="center">
                              <Box justifyContent="center" display="flex" gap="16px">
                                <Box>
                                  {doc?.status === "pending" && (
                                    <Button
                                      variant="primary"
                                      onClick={() => {
                                        setOpenAccept({
                                          id: doc?.id,
                                          state: true,
                                        });
                                      }}
                                    >
                                      {t("buttons.accept")}
                                    </Button>
                                  )}
                                </Box>
                                <Box>
                                  {doc?.status === "pending" && (
                                    <Button
                                      onClick={() => {
                                        setOpenRefuse({
                                          id: doc?.id,
                                          state: true,
                                        });
                                      }}
                                      variant="refuse"
                                    >
                                      {t("buttons.refuse")}
                                    </Button>
                                  )}
                                </Box>
                              </Box>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </StyledTable>
                  </TableContainer>
                </Box>
              )}
              {transactions?.length === 0 && !loading && <Typography textAlign="center">{t("pages.errors.no_transactions")}</Typography>}
              {transactions.length > 0 && (
                <Box justifyContent="flex-end" display="flex" gap="4px">
                  {page > 1 && (
                    <ButtonSquare
                      onClick={() => {
                        setPage(page - 1);
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                      action="Previous"
                    />
                  )}
                  <Box display="flex" gap="4px" justifyContent="center">
                    {pagesList.map((p) => (
                      <ButtonSquare
                        onClick={() => {
                          setPage(p);
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                        }}
                        action={p === page ? "number-active" : "number"}
                        number={p}
                      />
                    ))}
                  </Box>
                  {data?.pagination?.total - pageSize * page > 0 && (
                    <ButtonSquare
                      onClick={() => {
                        setPage(page + 1);
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                      action="Next"
                    />
                  )}
                </Box>
              )}
            </Box>
          </ContentBox>

          <Modal open={openAccept?.state} onClose={handleCloseAccept}>
            <Box sx={modalStyle}>
              <Box marginBottom="40px" display="flex" justifyContent="space-between" alignItems="center">
                <Typography color="#000000" fontSize="24px" fontWeight="600">
                  {t("pages.titles.accept_demand")}
                </Typography>
                <Box onClick={handleCloseAccept}>
                  <ButtonSquare action="close" />
                </Box>
              </Box>
              <Box>
                <Typography>{t("pages.titles.validation_accept")}</Typography>
              </Box>
              <Box display="flex" justifyContent="end" gap="10px">
                <Button onClick={handleCloseAccept} variant="refuse">
                  {t("buttons.cancel")}
                </Button>
                <Button onClick={handleAccept} variant="primary">
                  {t("buttons.accept")}
                </Button>
              </Box>
            </Box>
          </Modal>
          <Modal open={openRefuse?.state} onClose={handleCloseRefuse}>
            <Box sx={modalStyle}>
              <Box marginBottom="40px" display="flex" justifyContent="space-between" alignItems="center">
                <Typography color="#000000" fontSize="24px" fontWeight="600">
                  {t("pages.titles.refuse_demand")}
                </Typography>
                <Box onClick={handleCloseRefuse}>
                  <ButtonSquare action="close" />
                </Box>
              </Box>
              <Box marginBottom="16px">
                <Typography>{t("pages.titles.validation_refuse")}</Typography>
              </Box>
              <Box>
                <Box marginTop="16px" display="flex" justifyContent="end" gap="10px">
                  <Button onClick={handleCloseRefuse} variant="refuse">
                    {t("buttons.cancel")}
                  </Button>
                  <Button type="submit" onClick={handleRefuse} variant="primary">
                    {t("buttons.refuse")}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        </Box>
      </Box>
    </Box>
  );
};
export default WithdrawRequests;
